import { useEffect } from "react";

import { Route, Routes, useNavigate } from "react-router-dom";
import styled from "styled-components";
import invariant from "ts-invariant";

import { useProfileContext } from "contexts/ProfileContext";

import { getOnboardingFlow, useOnboardingNavigation } from "./utils";
import { Container } from "./views/styles";

export { useOnboardingNavigation };

export const OnboardingRoutes = (): JSX.Element => {
  const { profile } = useProfileContext();
  const navigate = useNavigate();

  invariant(profile);

  useEffect(() => {
    if (profile.state !== "in_onboarding") {
      navigate("/dashboard");
    }
  }, [profile]);

  const routes = getOnboardingFlow(profile);

  return (
    <OnboardingContainer>
      <Container>
        <Routes>
          {routes.map(route => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Routes>
      </Container>
    </OnboardingContainer>
  );
};

export const OnboardingContainer = styled.div`
  box-sizing: border-box;
  height: 100vh;
  width: 100%;
  padding: 50px 16px 30px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: ${({ theme }) => theme.colors.redesign.db1};

  ${({ theme }) => theme.aboveBreakpoint} {
    padding: 100px 15px 50px;
  }
`;
